import React from "react";
import Select from "react-select";

export default function EarningsMappingSection({
  unmappedRows,
  driverList,
  mappingUpdates,
  setMappingUpdates,
  onSaveMapping,
}) {
  
 
  // ---------------------------------------------
  // 🔍 Filter drivers ONLY by name (your request)
  // ---------------------------------------------
  
  const hasUnmapped = unmappedRows && unmappedRows.length > 0;

  return (
    <>
      {!hasUnmapped ? null : (
        <div
          style={{
            marginTop: 24,
            padding: 16,
            border: "1px solid #ddd",
            borderRadius: 8,
          }}
        >
          <h3>⚠ Unmapped Drivers Found</h3>
          <p>Please match the following drivers with your internal database.</p>

          
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: 10,
            }}
          >
            <thead>
              <tr>
                <th style={{ borderBottom: "1px solid #ccc" }}>Source</th>
                <th style={{ borderBottom: "1px solid #ccc" }}>External ID</th>
                <th style={{ borderBottom: "1px solid #ccc" }}>Driver Name</th>
                <th style={{ borderBottom: "1px solid #ccc" }}>Map To Driver</th>
              </tr>
            </thead>

            <tbody>
              {unmappedRows.map((row, idx) => {
                const isPlatform = !!row.driver_id && !!row.platform;
                const key = isPlatform ? row.driver_id : row.manualNameNorm;
                const displayName = isPlatform ? row.name : row.manualName;

                return (
                  <tr key={key || idx}>
                    <td
                      style={{
                        borderBottom: "1px solid #eee",
                        fontWeight: 600,
                        color: isPlatform ? "#0d47a1" : "#6a1b9a",
                      }}
                    >
                      {isPlatform ? row.platform.toUpperCase() : "MANUAL TRIP"}
                    </td>

                    <td style={{ borderBottom: "1px solid #eee" }}>
                      {isPlatform ? row.driver_id : "-"}
                    </td>

                    <td style={{ borderBottom: "1px solid #eee" }}>
                      {displayName}
                    </td>

                    <td style={{ borderBottom: "1px solid #eee" }}>
                      <Select
  options={driverList.map((d) => ({
    value: d.id,
    label: `${d.fullName} — ${d.phone || "No phone"} — ${d.carType || "Car?"} (${d.plateNumber || "Plate?"})`,
  }))}
  value={
    mappingUpdates[key]
      ? driverList
          .map((d) => ({
            value: d.id,
            label: `${d.fullName} — ${d.phone || "No phone"} — ${d.carType || "Car?"} (${d.plateNumber || "Plate?"})`,
          }))
          .find((o) => o.value === mappingUpdates[key])
      : null
  }
  onChange={(selectedOption) =>
    setMappingUpdates((prev) => ({
      ...prev,
      [key]: selectedOption.value,
    }))
  }
  placeholder="Search driver…"
  isSearchable={true}
  styles={{
    container: (base) => ({ ...base, width: "100%" }),
  }}
/>

                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <button
            onClick={onSaveMapping}
            style={{
              marginTop: 12,
              padding: "10px 18px",
              background: "#2e7d32",
              color: "white",
              border: "none",
              borderRadius: 6,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Save Driver Mappings
          </button>
        </div>
      )}
    </>
  );
}
